import React from "react";
import step1 from "@app/common/images/landing-page-step1.jpg";
import step2 from "@app/common/images/landing-page-step2.jpg";
import step3 from "@app/common/images/landing-page-step3.jpg";
import styled from "styled-components";
import { resource } from "@app/common/localization/resource";
import { mediaQuery } from "@app/common/responsive/mediaQuery";

export const SectionSteps: React.VFC = () => {
  const stepItem = (index: number, background: string) => (
    <div className={`row step${index}`}>
      <div className="col-md-6 text">
        <div className="step">
          <span className="step-number">{index}</span>
          <h2>{resource(`landing.step${index}Title`)}</h2>
          <p>{resource(`landing.step${index}Description`)}</p>
        </div>
      </div>
      <div className="col-md-6 image" style={{ backgroundImage: "url(" + background + ")" }} />
    </div>
  );

  return (
    <StyledSection>
      <div className="heading">
        <div className="container">
          <h1>{resource("landing.section3Title")}</h1>
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <p className="lead">{resource("landing.section3Description")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid steps">
        {stepItem(1, step1)}
        {stepItem(2, step2)}
        {stepItem(3, step3)}
      </div>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  margin-bottom: 60px;

  h1 {
    font-size: 32px;
    font-weight: 700;
    color: var(--heading-color);
    text-align: center;
  }

  .heading {
    padding: 80px 0;
  }

  .lead {
    font-size: 16px;
    text-align: center;
  }

  .steps {
    .row {
      background: #ebebeb;
      height: 415px;
    }

    .text {
      padding: 0;
      background: #ebebeb;
      display: flex;
      align-items: center;
    }

    .step {
      position: relative;
      max-width: 680px;
      padding: 0 100px 0 210px;

      .step-number {
        position: absolute;
        left: 100px;
        top: 10px;
        font-size: 40px;
        font-weight: bold;
        text-align: center;
        width: 80px;
        height: 80px;
        display: block;
        border: 6px solid var(--primary-color);
        border-radius: 40px;
      }

      h2 {
        margin: 0 0 15px;
        font-weight: 700;
        font-size: 32px;
      }

      p {
        font-size: 16px;
        font-weight: 600;
      }
    }

    .step1 {
      .text {
        padding-top: 60px;
        margin-top: -60px;
        justify-content: flex-end;
      }
      .image {
        background-position: 0 50%;
        background-size: cover;
      }
    }

    .step2 {
      .text {
        order: 1;
        justify-content: flex-start;
      }
      .image {
        order: 0;
        background-size: cover;
        background-position: 100% 0;
      }
    }

    .step3 {
      .text {
        padding-bottom: 60px;
        margin-bottom: -60px;
        justify-content: flex-end;
      }
      .image {
        background-position: 50% 50%;
        background-size: cover;
      }
    }

    ${mediaQuery({ to: "SM" })`
      .step1,
      .step2,
      .step3 {
        height: auto;

        .step {
          padding: 0 0 0 120px;

          .step-number {
            left: 0;
          }
        }

        .text {
          order: 2;
          padding: 20px 30px;
          margin: 0;
        }
        .image {
          order: 1;
          height: 200px;
        }
      }
  `}
  }
`;
